import { ModuleModeEnum } from '@/enums/ModuleModeEnum';

export default {
    indicator: ({ values }: { values: { mode: ModuleModeEnum; isAuto: boolean } }) => {
        const { mode, isAuto } = values;

        return `표시되는 부분을 큰 소리로 읽어주세요.
                    ${mode === ModuleModeEnum.SELF && !isAuto ? '지문을 클릭하면 구간이 이동해요.' : ''}`;
    },
    options: {
        title: '타이틀',
        readingType: {
            label: '읽기 단위',
            unit: '단위',
            meaning: '의미',
            sentence: '문장',
            paragraph: '문단',
        },
        readingMode: {
            label: '읽기 방식',
            all: '전체 읽기',
            split: '나눠 읽기',
            random: '돌아가며 읽기 (랜덤)',
            selected: '돌아가며 읽기 (지정)',
        },
        autoProgress: '자동 진행',
        autoProgressDesc: '글자당 0.4초로 계산해 자동으로 구간이 이동해요.',
        manualProgress: '수동 진행',
        manualProgressDesc: '클릭해서 구간을 이동해요.',
    },
    buttons: {
        next: '다음 학습하기',
        assign: '학생 지정하기',
        assignStudents: '학생 배정하기',
    },
    result: {
        done: '차근차근 읽기를 완료했어요!',
    },

    teacherFooter: {
        done: '다 읽었어요.',
        click: '지문 영역을 클릭해 주세요.',
    },
};
